import { FilterSelectionType } from '../FiltersContainer';

type AllSocialMediaPageFilters = {
    Accounts: any;
    Caption: any;
    'Media Type': any;
    startDate: FilterSelectionType | object;
    endDate: FilterSelectionType | object;
};

export const getFilterTagsDataFromFilters = (
    filters: AllSocialMediaPageFilters,
) => {
    return Object.values(filters)
        .filter((filter: any) => filter.displayValues?.length)
        .map((filter: any) => ({
            title: filter.title,
            selections: filter.displayValues,
        }));
};
